import React from 'react';
import { Box, Typography } from '@mui/material';
import { C, F } from '../styles/tokens';

/**
 * Consistent section header used across every section.
 *
 * @param {string}  label     - Uppercase eyebrow label (amber)
 * @param {string}  title     - Main heading (navy or white on dark)
 * @param {string}  [subtitle]- Optional subheading below the bar
 * @param {boolean} [centered]- Horizontally centre everything (default true)
 * @param {boolean} [dark]    - White title + amber bar for dark backgrounds
 * @param {number}  [mb]      - Bottom margin (MUI spacing units, default 5)
 */
const SectionHeader = ({ label, title, subtitle, centered = true, dark = false, mb = 5 }) => (
  <Box sx={{ textAlign: centered ? 'center' : 'left', mb }}>
    <Typography
      sx={{
        fontFamily:    F.heading,
        fontSize:      11,
        fontWeight:    700,
        letterSpacing: 3,
        textTransform: 'uppercase',
        color:         C.amber,
        mb:            1,
      }}
    >
      {label}
    </Typography>

    <Typography
      sx={{
        fontFamily: F.heading,
        fontSize:   { xs: 28, md: 38 },
        fontWeight: 800,
        color:      dark ? C.white : C.navy,
        lineHeight: 1.2,
        mb:         1,
      }}
    >
      {title}
    </Typography>

    <Box
      sx={{
        width:           52,
        height:          3,
        backgroundColor: dark ? C.amber : C.blue,
        borderRadius:    4,
        ...(centered ? { mx: 'auto' } : {}),
        ...(subtitle ? { mb: 2.5 } : {}),
      }}
    />

    {subtitle && (
      <Typography
        sx={{
          fontFamily: F.body,
          fontSize:   { xs: 14, md: 16 },
          color:      dark ? 'rgba(255,255,255,0.6)' : C.textMid,
          lineHeight: 1.7,
          maxWidth:   580,
          ...(centered ? { mx: 'auto' } : {}),
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
